module.exports = __webpack_public_path__ + "img/masonry-banner-2.0febe884.jpg";